import ComicCard from '@/components/base/ComicCard';
import { comics, latestComicIds } from '@/mocks/comics';

const latestComics = latestComicIds.map((id) => comics.find((c) => c.id === id)!);

export default function LatestSection() {
  return (
    <section id="latest" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-foreground-500 text-sm">每日更新，精彩不停</p>
          </div>
          <a href="#" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}